import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: (theme) => theme.palette.mode === 'dark' ? 'background.default' : '#f8f9fa'
    }}>
      <Header />
      <Container maxWidth="md" sx={{ py: 4, flex: 1 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              1. Information We Collect
            </Typography>
            <Typography variant="body1" paragraph>
              We collect information that you provide directly to us, including:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Account information (name, email address, password)<br />
              • Payment information (processed securely through our payment providers)<br />
              • Business information (company name, business type)<br />
              • Usage data and preferences
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              2. How We Use Your Information
            </Typography>
            <Typography variant="body1" paragraph>
              We use the information we collect to:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Provide, maintain, and improve our services<br />
              • Process your transactions and send related information<br />
              • Send you technical notices, updates, and support messages<br />
              • Respond to your comments and questions<br />
              • Monitor and analyze trends and usage
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              3. Information Sharing
            </Typography>
            <Typography variant="body1" paragraph>
              We do not sell your personal information. We may share your information with:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Service providers who assist in our operations<br />
              • Payment processors to handle transactions<br />
              • Legal authorities when required by law
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              4. Data Security
            </Typography>
            <Typography variant="body1" paragraph>
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              5. Your Rights
            </Typography>
            <Typography variant="body1" paragraph>
              You have the right to:
            </Typography>
            <Typography variant="body1" component="div" sx={{ pl: 2 }}>
              • Access your personal information<br />
              • Correct inaccurate information<br />
              • Request deletion of your information<br />
              • Object to processing of your information<br />
              • Export your data
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              6. Cookies and Tracking
            </Typography>
            <Typography variant="body1" paragraph>
              We use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              7. Children's Privacy
            </Typography>
            <Typography variant="body1" paragraph>
              Our service is not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              8. Changes to This Policy
            </Typography>
            <Typography variant="body1" paragraph>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              9. Contact Us
            </Typography>
            <Typography variant="body1" paragraph>
              If you have any questions about this Privacy Policy, please contact us at privacy@glowspirit.org.
            </Typography>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy; 